import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/shared/Loadable';

// General page routing
const DashboardPage = Loadable(lazy(() => import('views/adminViews/general/dashboard')));
const ActivityCalendarPage = Loadable(lazy(() => import('views/adminViews/general/activityCalendar/all')));
const CurrentWeekPage = Loadable(lazy(() => import('views/adminViews/general/currentWeek/all')));
const SchedulerPage = Loadable(lazy(() => import('views/adminViews/general/scheduler/all')));
const OperativeModePage = Loadable(lazy(() => import('views/adminViews/general/currentWeek/operativeMode/all')));

// Personal page routing
const MembersPage = Loadable(lazy(() => import('views/adminViews/personal/system/all')));
const GuardiansPage = Loadable(lazy(() => import('views/adminViews/personal/guardians/all')));
const GuardianDetailPage = Loadable(lazy(() => import('views/adminViews/personal/guardians/detail')));
const StudentsPage = Loadable(lazy(() => import('views/adminViews/personal/students/all')));
const StudentDetailPage = Loadable(lazy(() => import('views/adminViews/personal/students/detail')));
const TeachersPage = Loadable(lazy(() => import('views/adminViews/personal/teachers/all')));
const ServicesPage = Loadable(lazy(() => import('views/adminViews/personal/services/all')));
const ArchivePage = Loadable(lazy(() => import('views/adminViews/personal/archive/all')));

// Administration page routing
const AccountingPage = Loadable(lazy(() => import('views/adminViews/administration/accounting/all')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/dashboard',
            element: <DashboardPage />
        },
        {
            path: '/calendario/attivita',
            element: <ActivityCalendarPage />
        },
        {
            path: '/settimana/corrente',
            element: <CurrentWeekPage />
        },
        {
            path: '/modalita/operativa',
            element: <OperativeModePage />
        },
        {
            path: '/schedulatore',
            element: <SchedulerPage />
        },
        {
            path: '/anagrafiche/tutori',
            element: <GuardiansPage />
        },
        {
            path: '/anagrafiche/tutori/dettaglio/:id',
            element: <GuardianDetailPage />
        },
        {
            path: '/anagrafiche/alunni',
            element: <StudentsPage />
        },
        {
            path: '/anagrafiche/alunni/dettaglio/:id',
            element: <StudentDetailPage />
        },
        {
            path: '/anagrafiche/insegnanti',
            element: <TeachersPage />
        },
        {
            path: '/anagrafiche/servizi',
            element: <ServicesPage />
        },
        {
            path: '/amministrazione/contabilita',
            element: <AccountingPage />
        },
        {
            path: '/anagrafiche/sistema',
            element: <MembersPage />
        },
        {
            path: '/archivio/anagrafiche',
            element: <ArchivePage />
        },
        {
            path: '/archivio/anagrafiche/tutori/dettaglio/:id',
            element: <GuardianDetailPage />
        },
    ]
};

export default MainRoutes;